// ========================================
// COMPONENTS / Navbar.jsx
// ========================================

import React, { useState, useRef, useEffect } from "react";
import { useScrolled } from "../hooks";
import { PRODUCTS_DATA } from "../data/products";
import styles from "./Navbar.module.css";

const NAV_MENU = [
  { label: "Home",         id: "home"         },
  { label: "Categories",   id: "products"     },
  { label: "Best Sellers", id: "best-sellers" },
  { label: "About Us",     id: "about"        },
  { label: "Our Team",     id: "our-team"     },
  { label: "Contact Us",   id: "contact"      },
];

function scrollTo(id) {
  if (id === "home") {
    window.scrollTo({ top: 0, behavior: "smooth" });
  } else {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  }
}

function BurgerMenu({ open, onClose }) {
  return (
    <>
      {/* Overlay */}
      <div
        className={`${styles.overlay} ${open ? styles.overlayOpen : ""}`}
        onClick={onClose}
      />
      {/* Drawer */}
      <div className={`${styles.drawer} ${open ? styles.drawerOpen : ""}`}>
        <button className={styles.closeBtn} onClick={onClose} aria-label="Close menu">✕</button>
        <img
          src="/newlogo.png"
          alt="Moon Berry"
          className={styles.drawerLogo}
        />
        <nav className={styles.drawerNav}>
          {NAV_MENU.map(({ label, id }) => (
            <button
              key={id}
              className={styles.drawerLink}
              onClick={() => { scrollTo(id); onClose(); }}
            >
              {label}
            </button>
          ))}
        </nav>
      </div>
    </>
  );
}

function SearchBar() {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  const handleChange = (e) => {
    const val = e.target.value;
    setQuery(val);
    if (val.trim().length < 2) { setResults([]); setOpen(false); return; }
    const q = val.toLowerCase();
    const matched = PRODUCTS_DATA.filter(
      (p) =>
        p.name.toLowerCase().includes(q) ||
        p.category.toLowerCase().includes(q) ||
        p.subCategory.toLowerCase().includes(q)
    ).slice(0, 8);
    setResults(matched);
    setOpen(true);
  };

  useEffect(() => {
    const handler = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleSelect = (product) => {
    setQuery("");
    setOpen(false);
    if (product.link) {
      const a = document.createElement("a");
      a.href = product.link;
      a.target = "_blank";
      a.rel = "noopener noreferrer";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } else {
      const el = document.getElementById("products");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className={styles.searchWrap} ref={wrapRef}>
      <svg className={styles.searchIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
      </svg>
      <input
        type="text"
        placeholder="Search products..."
        className={styles.searchInput}
        value={query}
        onChange={handleChange}
        onFocus={() => results.length > 0 && setOpen(true)}
      />
      {open && results.length > 0 && (
        <div className={styles.searchDropdown}>
          {results.map((p) => (
            <div key={p.code} className={styles.searchResult} onClick={() => handleSelect(p)}>
              {p.images[0] && (
                <img src={`/products/${encodeURIComponent(p.images[0])}`} alt={p.name} className={styles.resultImg} />
              )}
              <div className={styles.resultInfo}>
                <div className={styles.resultName}>{p.name}</div>
                <div className={styles.resultMeta}>{p.category} · AED {Number(p.price).toFixed(0)}</div>
              </div>
              {p.link && <span className={styles.resultArrow}>→</span>}
            </div>
          ))}
        </div>
      )}
      {open && query.length >= 2 && results.length === 0 && (
        <div className={styles.searchDropdown}>
          <div className={styles.noResults}>No products found</div>
        </div>
      )}
    </div>
  );
}

export default function Navbar() {
  const scrolled = useScrolled(40);
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <header className={`${styles.header} ${scrolled ? styles.scrolled : ""}`}>
        <div className={styles.container}>

          {/* Left — burger */}
          <button
            className={styles.burger}
            onClick={() => setMenuOpen(true)}
            aria-label="Open menu"
          >
            <span /><span /><span />
          </button>

          {/* Center — logo */}
          <a href="#" className={styles.logo} onClick={(e) => { e.preventDefault(); scrollTo("home"); }}>
            <img
              src="/newlogo.png"
              alt="Moon Berry"
              className={styles.logoImg}
            />
          </a>

          {/* Right — search */}
          <SearchBar />

        </div>
      </header>

      <BurgerMenu open={menuOpen} onClose={() => setMenuOpen(false)} />
    </>
  );
}
